import { render, staticRenderFns } from "./DetailHasilUjianPOLRI.vue?vue&type=template&id=86a66d3e"
import script from "./DetailHasilUjianPOLRI.vue?vue&type=script&lang=js"
export * from "./DetailHasilUjianPOLRI.vue?vue&type=script&lang=js"
import style0 from "./DetailHasilUjianPOLRI.vue?vue&type=style&index=0&id=86a66d3e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports